export type PackGroupSeed = {
  packId: number;
  packName: string;
  storeIds: number[];
  formatEntries: Array<{ mediaFormatId: number; quantity: number }>;
};

export type ImportedPackGroup = {
  groupId: string;
  groupName: string;
  storeIds: number[];
  formatEntries: Array<{ mediaFormatId: number; quantity: number }>;
  operatorTaskId: null;
  storeCoverageOverrides: Record<number, number>;
  seedPackId: number;
  seedPackName: string;
};

export function packNamesForRow(row: { importPackNames?: string[]; importPackName: string }): string[] {
  if (row.importPackNames && row.importPackNames.length > 0) {
    return row.importPackNames;
  }
  return row.importPackName
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);
}

export function buildImportedPackGroups(args: {
  packNames: string[];
  resolvePackId: (importPackName: string) => number | null;
  seeds: PackGroupSeed[];
  createGroupId?: () => string;
}): { groups: ImportedPackGroup[]; error: string | null } {
  const seedByPackId = new Map(args.seeds.map((seed) => [seed.packId, seed]));
  const groups: ImportedPackGroup[] = [];

  for (const packName of args.packNames) {
    const packId = args.resolvePackId(packName);
    if (!packId) {
      return { groups: [], error: `No confirmed pack mapping for "${packName}".` };
    }
    const seed = seedByPackId.get(packId);
    if (!seed || seed.storeIds.length === 0) {
      return { groups: [], error: `Pack "${seed?.packName ?? packName}" has no stores to seed a group.` };
    }
    if (seed.formatEntries.length === 0) {
      return { groups: [], error: `Pack "${seed.packName}" has no formats to seed a group.` };
    }
    groups.push({
      groupId: args.createGroupId ? args.createGroupId() : `group-${packId}`,
      groupName: seed.packName,
      storeIds: seed.storeIds,
      formatEntries: seed.formatEntries,
      operatorTaskId: null,
      storeCoverageOverrides: {},
      seedPackId: packId,
      seedPackName: seed.packName,
    });
  }

  return { groups, error: null };
}
